import { Box, HStack, VStack, Text } from '@chakra-ui/react';
import { HiCheck, HiDocument } from 'react-icons/hi2';
import { FaWhatsapp } from 'react-icons/fa';
import dayjs from 'dayjs';

const UserBubble = ({ message, colors }) => {
    const isWhatsApp = message.source === 'whatsapp';

    const renderContent = () => {
        if (message.type === 'image' && message.content) {
            return (
                <img
                    src={message.content}
                    alt={message.filename}
                    style={{ maxWidth: '240px', maxHeight: '320px', borderRadius: '8px', display: 'block' }}
                />
            );
        }
        if (message.type === 'audio' && message.content) {
            return (
                <Box>
                    <audio controls src={message.content} style={{ maxWidth: '100%' }} />
                    {message.text && <Text fontSize="xs" color="rgba(255,255,255,0.7)" mt={1}>{message.text}</Text>}
                </Box>
            );
        }
        if (message.type === 'video' && message.content) {
            return (
                <Box>
                    <video controls src={message.content} style={{ maxWidth: '100%', borderRadius: 6 }} />
                    {message.text && <Text fontSize="xs" color="rgba(255,255,255,0.7)" mt={1}>{message.text}</Text>}
                </Box>
            );
        }
        if ((message.type === 'document' || message.type === 'file') && message.filename) {
            return (
                <Box>
                    <Text
                        as="a"
                        href={message.content ?? undefined}
                        download={message.filename}
                        fontSize="sm"
                        color="white"
                        textDecoration={message.content ? 'underline' : 'none'}
                        cursor={message.content ? 'pointer' : 'default'}
                        display="flex"
                        alignItems="center"
                        gap={2}
                    >
                        <HiDocument size={18} color="rgba(255,255,255,0.8)" />
                        {message.filename}
                    </Text>
                    {message.text && message.text !== message.filename &&
                        <Text fontSize="xs" color="rgba(255,255,255,0.7)" mt={1}>{message.text}</Text>}
                </Box>
            );
        }
        return (
            <Text fontSize="sm" color="white" whiteSpace="pre-wrap" lineHeight="1.5">
                {message.text}
            </Text>
        );
    };

    return (
        <VStack gap={1} alignItems="flex-end" maxW="85%">
            <Box
                bg={colors.userBubble}
                borderRadius="18px"
                borderBottomRightRadius="4px"
                px={4}
                py={3}
                maxW="100%"
            >
                {isWhatsApp && (
                    <HStack mb={1} gap={1}>
                        <FaWhatsapp color="#25D366" size={12} />
                        <Text fontSize="10px" color="#25D366">WhatsApp</Text>
                    </HStack>
                )}
                {renderContent()}
            </Box>
            <HStack gap={1} px={1}>
                <Text fontSize="xs" color={colors.dateText}>
                    {dayjs(message.timestamp).format('HH:mm')}
                </Text>
                <HiCheck size={14} color={colors.dateText} />
            </HStack>
        </VStack>
    );
};

export default UserBubble;
